/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { FeatureFlagListResponse } from '../types/FeatureFlagList'

/**
 * GET /features
 * @see backend/nexus/modules/FeatureFlag/Http/Controllers/FeatureFlagController.php FeatureFlagController::list
 */
export async function featureFlagList(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<FeatureFlagListResponse>> {
	return axiosInstance.get('/features', config)
}
